import { Component, Input } from '@angular/core';
import { ProgressBarComponent } from '../../progress-bar/progress-bar.component';
import { VesselTank } from '../../vessel-tank.model';

@Component({
  selector: 're-tank-summary',
  templateUrl: './tank-summary.component.html',
  styleUrl: './tank-summary.component.css',
  imports: [ProgressBarComponent],
})
export class TankSummaryComponent {
  @Input({ required: true }) tankNumber!: number;
  @Input({ required: true }) tankName!: string;
  @Input({ required: true }) fuelGrade!: string;
  @Input({ required: true }) progress!: number;
  @Input({ required: true }) tank!: VesselTank;
  @Input({ required: true }) quantity!: number;
  @Input() progress2 = 0;

  get label(): string {
    return `${this.quantity} MT (${this.progress.toFixed(2)}%)`;
  }
}
